<template>
  <div class="container py-3">
    <div class="row">
      <div class="mx-auto col-md-8">
        <!-- form user info -->
        <div class="card">
            <div class="card-header">
              <h4 class="mb-0">فرم اطلاعات پزشک</h4>
            </div>
            <div class="card-body">
              <form class="form" role="form" autocomplete="off">
                  <div class="form-group row">
                      <label class="col-lg-3 col-form-label form-control-label">نام</label>
                      <div class="col-lg-9">
                          <input class="form-control" type="text" v-model="model.firstname" required >
                      </div>
                  </div>
                  <div class="form-group row">
                      <label class="col-lg-3 col-form-label form-control-label">نام خانوادگی</label>
                      <div class="col-lg-9">
                          <input class="form-control" type="text" v-model="model.lastname" required>
                      </div>
                  </div>
                  <div class="form-group row">
                      <label class="col-lg-3 col-form-label form-control-label">شماره نظام پزشکی</label>
                      <div class="col-lg-9">
                          <input class="form-control" type="number" min="0" v-model="model.councilNo" required>
                      </div>
                  </div>
                  <div class="form-group row">
                      <label class="col-lg-3 col-form-label form-control-label">کد ملی</label>
                      <div class="col-lg-9">
                          <input class="form-control" type="number" min="0" v-model="model.nationalCode" required>
                      </div>
                  </div>
                  <div class="form-group row">
                      <label class="col-lg-3 col-form-label form-control-label">جنسیت</label>
                      <div class="col-lg-9">
                          <select class="form-control" v-model="model.gender">
                              <option value="1">مرد</option>
                              <option value="2">زن</option>
                          </select>
                      </div>
                  </div>
                  <div class="form-group row">
                      <label class="col-lg-3 col-form-label form-control-label">رشته تحصیلی</label>
                      <div class="col-lg-9">
                        <select class="form-control" v-model="model.majorId">
                          <option v-for="(item, index) in $root.majors" :key="index" :value="item.id">{{item.name}}</option>
                        </select>
                      </div>
                  </div>
                  <div class="form-group row">
                      <label class="col-lg-3 col-form-label form-control-label">شماره پروانه</label>
                      <div class="col-lg-9">
                          <input class="form-control" type="text" v-model="model.licenseNo" required>
                      </div>
                  </div>
                  <div class="form-group row">
                      <label class="col-lg-3 col-form-label form-control-label">تاریخ صدور پروانه</label>
                      <div class="col-lg-9">
                          <input class="form-control" type="text" placeholder="مثال : 1397/12/28" required v-model="model.licenseExportDate" @blur="$root.checkPersianDate">
                      </div>
                  </div>
                  <div class="form-group row">
                      <label class="col-lg-3 col-form-label form-control-label">تاریخ انقضاء پروانه</label>
                      <div class="col-lg-9">
                          <input class="form-control" type="text" placeholder="مثال : 1397/12/28" required v-model="model.licenseExpireDate" @blur="$root.checkPersianDate">
                      </div>
                  </div>
                  <div class="form-group row">
                      <label class="col-lg-3 col-form-label form-control-label">شهر محل فعالیت</label>
                      <div class="col-lg-9">
                        <select class="form-control" v-model="model.cityId">
                          <option v-for="(item, index) in $root.cities" :key="index" :value="item.id">{{item.name}}</option>
                        </select>
                      </div>
                  </div>
                  <div class="form-group row">
                      <label class="col-lg-3 col-form-label form-control-label">آدرس مطب</label>
                      <div class="col-lg-9">
                          <input class="form-control" type="text" v-model="model.officeAddress" required>
                      </div>
                  </div>
                  <div class="form-group row">
                      <label class="col-lg-3 col-form-label form-control-label">محل کار</label>
                      <div class="col-lg-9">
                          <input class="form-control" type="text" v-model="model.workLocation">
                      </div>
                  </div>
                  <div class="form-group row">
                      <label class="col-lg-3 col-form-label form-control-label">تلفن مطب</label>
                      <div class="col-lg-9">
                          <input class="form-control" type="text" v-model="model.officeTel">
                      </div>
                  </div>
                  <div class="form-group row">
                      <label class="col-lg-3 col-form-label form-control-label">تلفن همراه</label>
                      <div class="col-lg-9">
                          <input class="form-control" type="text" v-model="model.mobileNo" required>
                      </div>
                  </div>
                  <div class="form-group row">
                      <label class="col-lg-3 col-form-label form-control-label">آدرس منزل</label>
                      <div class="col-lg-9">
                          <input class="form-control" type="text" v-model="model.homeAddress">
                      </div>
                  </div>
                  <div class="form-group row">
                      <label class="col-lg-3 col-form-label form-control-label">تلفن منزل</label>
                      <div class="col-lg-9">
                          <input class="form-control" type="text" v-model="model.homeTel">
                      </div>
                  </div>
                  <!-- <div class="form-group row">
                      <label class="col-lg-3 col-form-label form-control-label">کد امنیتی</label>
                      <div class="col-lg-9">
                          <img id="img-captcha" :src="captchaData" />
                          <input class="form-control col-lg-7 h-100 float-left" type="text" v-model="model.captcha" required>
                      </div>
                  </div> -->
                  <div class="form-group row justify-content-end">
                      <div class="col-lg-6">
                          <input type="reset" class="btn btn-secondary" value="انصراف" @click="btnCancelClick()">
                          <input type="button" class="btn btn-primary" value="ثبت مشخصات" @click="btnSaveClick">
                      </div>
                  </div>
              </form>
            </div>
        </div>
        <!-- /form user info -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'register-form',
  data () {
    return {
      model: {gender: 1, majorId: 1, cityId: 1},
      captchaData: ''
    }
  },
  computed: {
    isEditMode () {
      return this.$root.member !== null
    }
  },
  methods: {
    loadCaptcha () {
      let url = this.$root.apiUrl + '/Members/captcha'
      this.$http
        .get(url)
        .then(res => {
          this.captchaData = 'data:image/Png;base64,' + res.data
        })
        .catch(err => {
          console.error(err)
        })
    },
    btnSaveClick () {
      if (this.$el.querySelector('form').reportValidity() !== true) {
        return
      }
      if (this.model.licenseExportDate) {
        this.model.licenseExportDate = this.$root.toGregorianDate(this.model.licenseExportDate)
      }
      if (this.model.licenseExpireDate) {
        this.model.licenseExpireDate = this.$root.toGregorianDate(this.model.licenseExpireDate)
      }
      let url = this.$root.apiUrl + '/Members/Register'
      this.$http
        .post(url, this.model)
        .then(res => {
          console.info('Success', res.data)
          this.$router.replace('/done')
        })
        .catch(err => {
          alert('خطا در هنگام ثبت اطلاعات')
          console.error(err)
          // this.$router.replace('/')
        })
    },
    btnCancelClick () {
      this.$router.replace('/')
    }
  },
  mounted () {
    if (this.isEditMode) {
      this.model = this.$root.member
    }
    this.loadCaptcha()
  }
}
</script>

<style scoped>
#img-captcha {
    width: 170px;
    height: 50px;
    float: right;
}
</style>



// WEBPACK FOOTER //
// src/components/RegisterForm.vue